import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Chip,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useEffect, useState } from "react";

export const TodoTabIssues = () => {
  const [issues, setIssues] = useState([]);

  const traerProblemas = async () => {
    try {
      const response = await fetch(`/api/v1/buzon?type=problema`);
      const data = await response.json();

      if (!data.ok) {
        return;
      }

      //Darle formato a los datos
      data.data.forEach((issue) => {
        issue.relevance = relevance[issue.relevance];
        issue.status = status[issue.status];
      });

      setIssues(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    traerProblemas();
  }, []);

  if (issues.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        No hay problemas
      </Typography>
    );
  }

  return (
    <>
      {issues.map((issue) => (
        <Accordion key={issue.id}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="subtitle1">{issue.title}</Typography>
              <Typography variant="body2" color="textSecondary">
                {new Date(issue.date).toLocaleDateString()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" color="textSecondary">
              {issue.description}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Chip label={issue.status.name} color={issue.status.color} />
              <Chip
                label={issue.relevance.name}
                color={issue.relevance.color}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
